/**
 * blog-tipp-injector.js
 *
 * Moves pre-rendered hidden tipp box wrappers to after their marker elements
 * inside .blog-post-content.
 *
 * Mirrors the old jQuery pattern:
 *   $(".article__blog-tipp-wrapper").insertAfter(".blog-tipp-section-above");
 */

function moveTipp(wrapperSelector, markerClass) {
  const wrapper = document.querySelector(wrapperSelector);
  if (!wrapper) return;

  let marker = null;
  for (const div of document.querySelectorAll('.blog-post-content')) {
    marker = div.querySelector('.' + markerClass);
    if (marker) break;
  }
  if (!marker) return;

  marker.after(wrapper);
  wrapper.style.display = '';
}

function runTippInjection() {
  moveTipp('.blog-tipp-wrapper',   'blog-tipp-section-above');
  moveTipp('.blog-tipp-wrapper-2', 'blog-tipp-section-above-2');
  moveTipp('.blog-tipp-wrapper-3', 'blog-tipp-section-above-3');
}

// type="module" already defers to after HTML parsing — DOM is ready.
runTippInjection();